import { Component, ElementRef, ViewChild } from '@angular/core';
import { AppUsersDto } from '../../model/app-users-dto';
import { ShowpopupDirective } from '../../directives/showpopup.directive';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { CommonService } from '../../service/common.service';
import { ToastrService } from 'ngx-toastr';
import { LoggedInUserService } from '../../service/logged-in-user.service';
import { Router } from '@angular/router';
import { HrService } from 'src/app/hr/hr.service';
import { HttpStatusCode } from '@angular/common/http';
import { ChangePasswordFormComponent } from '../popup-forms/change-password-form/change-password-form.component';
import { LoggedInSuperAdminKeys, SuperAdminLoginService } from '../../service/super-admin-login.service';

@Component({
    selector: 'app-super-admin-header',
    templateUrl: './super-admin-header.component.html',
    standalone: false
})
export class SuperAdminHeaderComponent {
  loginUser: any;
  @ViewChild(ShowpopupDirective, { static: false })
  loadPopup!: ShowpopupDirective;
  resetPasswordForm: FormGroup;
  private closeSubscription!: Subscription;
  confirmpassword: string;
  @ViewChild('dropdownElement') dropdownElement: ElementRef;
  constructor(public _commonServices: CommonService,
    private _loggedInSuperAdminService: SuperAdminLoginService, private _toaster: ToastrService, private _router: Router, private fb: FormBuilder, private hrService: HrService) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.loginUser = this._loggedInSuperAdminService.getLoggedInUser(LoggedInSuperAdminKeys.SUPER_ADMIN_LOGGED_IN);
    }, 100);
    // this.resetFormCreate();
  }

  logOut() {
    this._commonServices.logoutUser().subscribe((response) => {
      if (response.statusCode === HttpStatusCode.Ok) {
        this._toaster.success(response.message, 'info');
        this._loggedInSuperAdminService.clearEntireStorage();
        this._router.navigate([this._commonServices.SuperAdminNavigations.SUPER_ADMIN_SIGNIN]);
      }
    })
  }

  isOpen = false;
  togglePopup() {
    this.isOpen = !this.isOpen;
  }
  closeDropdown() {
    this.isOpen = false;
  }

  getUsernameInitials(name: any) {
    const matches = name?.match(/\b(\w)/g);
    return matches?.join('');
  }

  resetFormCreate() {
    this.resetPasswordForm = this.fb.group(
      {
        email: [''],
        oldPassword: ['', [Validators.required]],
        newPassword: ['', [Validators.required, this.passwordValidator]],
        confirmPassword: [
          '',
          Validators.required,
        ],
      },
      { validators: this.passwordMatchingValidatior }

    );
  }
  passwordMatchingValidatior: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const password = control.get("newPassword");
    const confirmPassword = control.get("confirmPassword");
    return password?.value === confirmPassword?.value
      ? null
      : { notmatched: true };
  }
  openChangePasswordPopup() {
    const hostViewContainerRef = this.loadPopup.viewPopup;

    hostViewContainerRef.clear();

    const componentRef = hostViewContainerRef.createComponent(ChangePasswordFormComponent);

    this.closeSubscription = componentRef.instance.close.subscribe(() => {
      this.closeSubscription.unsubscribe();
      hostViewContainerRef.clear();
    });
    this.closeSubscription = componentRef.instance.confirmPasswordCheck.subscribe(
      (el) => {
        this.confirmpassword = el;
      }

    );
    componentRef.instance.resetPasswordForm = this.resetPasswordForm
    if (this.loginUser) {
      componentRef.instance.getLoginEmail = this.loginUser.email;
    }
  }

  passwordValidator(control: AbstractControl): ValidationErrors | null {
    const passwordPattern =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?\d)(?=.*?[!@#$%^&*()_+])[\w!@#$%^&*()_+]{8,}$/;
    if (!passwordPattern.test(control.value)) {
      return { invalidPassword: true };
    }
    return null;
  }

  // downloadMergedVideo() {
  //   this.hrService.downloadMergedVideo().subscribe((response) => {
  //     if(response && response.statusCode === HttpStatusCode.Ok){
  //       let fileType: any =
  //           'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  //         let link = document.createElement('a');
  //         link.href = `data:${fileType};base64,${response.data}`;
  //         link.download = 'merged_video_details';
  //         link.click();
  //     }
  //   })
  // }
  navToReportedQuestion() {
    this._router.navigate([this._commonServices.Navigations.REPORTED_QUESTION]);
  }

  navToServerHealthCheck() {
    this._router.navigate([this._commonServices.Navigations.SERVER_HEALTH_CHECK]);
  }

  routeToWorkdayFailures(){
   this._router.navigate([this._commonServices.Navigations.WORKDAY_FAILURES]);
  }

}